import {useMatch} from 'react-router-dom';
import {useAppSelector} from 'store/customer';
import {selectLeftSidebar, SidebarStatus} from 'store/customer/UISlice';

export const useRoomPlannerLeftMenu = () => {
    const leftSidebarStatus = useAppSelector(selectLeftSidebar);
    const isRoomPlannerPage = useMatch(
        '/v2/job/:jobId/room/:roomId/room-planner'
    );

    const isMenuOpen =
        leftSidebarStatus === SidebarStatus.OPEN && !!isRoomPlannerPage;

    return {
        isRoomPlannerPage,
        isMenuOpen,
    };
};
